import { render } from "./GallaryView.vue?vue&type=template&id=a02dedba&scoped=true"
import script from "./GallaryView.vue?vue&type=script&lang=js"
export * from "./GallaryView.vue?vue&type=script&lang=js"

import "./GallaryView.vue?vue&type=style&index=0&id=a02dedba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a02dedba"]])

export default __exports__